import type { FunctionComponent } from "react";
import StatsSliderMenuPartial from "../../../../partials/admin/menus/favourites/stats-slider-menu.admin.partials";

export const StatsSliderMenuAdminScreen: FunctionComponent = () => {
    return <StatsSliderMenuPartial />;
};
